/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ============================================
// Replace Shopify "availability" alert with inline error
// ============================================
(function() {
  'use strict';
  var galleryRequestCache = {};

  var lastAddToCartButton = null;

  // Track the last clicked Add to Cart button
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('.ProductForm__AddToCart');
    if (btn) {
      lastAddToCartButton = btn;
    }
  }, true);

  // Override window.alert to catch the availability message
  var originalAlert = window.alert;
  window.alert = function(message) {
    try {
      var isAvailabilityMessage = typeof message === 'string' &&
        (message.indexOf('added to your cart due to availability') !== -1 ||
         message.indexOf('The maximum quantity of this item is already in your cart') !== -1);

      if (isAvailabilityMessage) {
        var targetButton = lastAddToCartButton || document.querySelector('.ProductForm__AddToCart');
        if (targetButton) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.textContent = message;
          targetButton.insertAdjacentElement('afterend', errorMessageElement);

          setTimeout(function() {
            if (errorMessageElement && errorMessageElement.parentNode) {
              errorMessageElement.parentNode.removeChild(errorMessageElement);
            }
          }, 2500);

          // Also ensure cart UI reflects the updated cart:
          // - Ask the theme/cart drawer to refresh from the real cart
          // - Fire a product:added event (quantity 0 so counts don't change optimistically)
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

            document.dispatchEvent(new CustomEvent('product:added', {
              detail: {
                variant: null,
                quantity: 0
              }
            }));
          } catch (e2) {}

          return;
        }
      }
    } catch (e) {
      // fall through to default alert
    }

    return originalAlert.apply(window, arguments);
  };
})();

// ============================================
// PDP Add-to-cart submit fallback (prevent page reload)
// ============================================
(function() {
  'use strict';

  function isProductAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (!form.classList.contains('ProductForm')) return false;
    return form.action && form.action.indexOf('/cart/add') !== -1;
  }

  function parseQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function buildPayload(form) {
    var payload = {};
    var formData = new FormData(form);

    formData.forEach(function(value, key) {
      payload[key] = value;
    });

    return payload;
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;

    if (!isProductAddToCartForm(form)) return;

    var ajaxButton = form.querySelector('[data-action="add-to-cart"]');
    if (!ajaxButton) return;

    var submitter = event.submitter;
    // Run fallback only for the main product add-to-cart button submit.
    if (!submitter) return;
    if (!submitter.matches('[data-action="add-to-cart"], .ProductForm__AddToCart')) return;

    // If the submit came from dynamic checkout, don't interfere.
    if (submitter && submitter.closest('.shopify-payment-button')) return;

    event.preventDefault();
    event.stopPropagation();

    if (ajaxButton.disabled) return;

    ajaxButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var payload = buildPayload(form);
    var quantity = parseQuantity(form);
    var addUrl = (window.theme && window.theme.localeRootUrl ? window.theme.localeRootUrl : '') + '/cart/add.js';

    fetch(addUrl, {
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (response.ok) {
        response.json().then(function(addedItem) {
          ajaxButton.removeAttribute('disabled');
          form.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: addedItem || null,
              quantity: quantity
            }
          }));
        });
        return;
      }

      response.json().then(function(content) {
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = content && content.description ? content.description : 'Unable to add this product to cart.';
        ajaxButton.removeAttribute('disabled');
        ajaxButton.insertAdjacentElement('afterend', errorMessageElement);
        setTimeout(function() {
          errorMessageElement.remove();
        }, 2500);
      });
    }).catch(function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      ajaxButton.removeAttribute('disabled');
    });
  }, true);
})();

// ============================================
// PDP Add-to-cart loading label sync
// ============================================
(function() {
  'use strict';

  var activeButtons = [];
  var restoreTimer = null;
  var isAtcPending = false;
  var LOADING_LABEL = 'Adding...';

  function uniqueButtons(buttons) {
    var seen = [];
    var result = [];

    buttons.forEach(function(btn) {
      if (!btn) return;
      if (seen.indexOf(btn) !== -1) return;
      seen.push(btn);
      result.push(btn);
    });

    return result;
  }

  function getLinkedButtons(clickedButton) {
    var buttons = [clickedButton];
    var stickyButton = document.querySelector('#ProductStickyBar .ProductStickyBar__AddToCart');
    var mainButton = document.querySelector('form.ProductForm .ProductForm__AddToCart');

    if (clickedButton.matches('.ProductForm__AddToCart') && stickyButton) {
      buttons.push(stickyButton);
    }

    if (clickedButton.matches('.ProductStickyBar__AddToCart') && mainButton) {
      buttons.push(mainButton);
    }

    return uniqueButtons(buttons);
  }

  function setButtonLoading(button) {
    if (!button) return;
    if (!button.dataset.atcOriginalHtml) {
      button.dataset.atcOriginalHtml = button.innerHTML;
    }
    button.innerHTML = '<span>' + LOADING_LABEL + '</span>';
    button.classList.add('is-adding');
    button.setAttribute('aria-busy', 'true');
  }

  function restoreButton(button) {
    if (!button) return;
    if (button.dataset.atcOriginalHtml) {
      button.innerHTML = button.dataset.atcOriginalHtml;
      delete button.dataset.atcOriginalHtml;
    }
    button.classList.remove('is-adding');
    button.removeAttribute('aria-busy');
  }

  function clearLoadingState() {
    if (!isAtcPending) return;

    activeButtons.forEach(restoreButton);
    activeButtons = [];
    isAtcPending = false;

    if (restoreTimer) {
      clearTimeout(restoreTimer);
      restoreTimer = null;
    }
  }

  document.addEventListener('click', function(event) {
    var clickedButton = event.target.closest('.ProductForm__AddToCart, .ProductStickyBar__AddToCart');
    if (!clickedButton || clickedButton.disabled) return;

    clearLoadingState();
    activeButtons = getLinkedButtons(clickedButton);
    activeButtons.forEach(setButtonLoading);
    isAtcPending = true;

    // Safety fallback in case a third-party flow doesn't emit normal events.
    restoreTimer = setTimeout(clearLoadingState, 8000);
  }, true);

  document.addEventListener('product:added', clearLoadingState);
  document.addEventListener('theme:loading:end', clearLoadingState);
})();

// Make Faq__Icon behave like Faq__Question (toggle accordion)
document.addEventListener('click', function (event) {
  var icon = event.target.closest('.Faq__Icon');
  if (!icon) return;

  var item = icon.closest('.Faq__Item');
  if (!item) return;

  var question = item.querySelector('.Faq__Question');
  if (question) {
    question.click();
  }
});


// Toggle password visibility on the login page
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-action="toggle-password-visibility"]');
  if (!toggle) return;

  var item = toggle.closest('.Form__Item');
  if (!item) return;

  var input = item.querySelector('input.Form__Input[type="password"], input.Form__Input[type="text"]');
  if (!input) return;

  var isHidden = input.type === 'password';
  input.type = isHidden ? 'text' : 'password';
  toggle.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
  
  // Toggle eye icons
  var eyeIcon = toggle.querySelector('.password-icon-eye');
  var eyeSlashIcon = toggle.querySelector('.password-icon-eye-slash');
  
  if (eyeIcon && eyeSlashIcon) {
    if (isHidden) {
      // Password is now visible - show eye with slash
      eyeIcon.style.display = 'none';
      eyeSlashIcon.style.display = 'block';
    } else {
      // Password is now hidden - show normal eye
      eyeIcon.style.display = 'block';
      eyeSlashIcon.style.display = 'none';
    }
  }
});


// Newsletter duplicate email detection
(function() {
  'use strict';
  
  // Get subscribed emails from localStorage
  function getSubscribedEmails() {
    try {
      var stored = localStorage.getItem('newsletter_subscribed_emails');
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }
  
  // Save subscribed email to localStorage
  function saveSubscribedEmail(email) {
    try {
      var emails = getSubscribedEmails();
      var normalizedEmail = email.toLowerCase().trim();
      if (emails.indexOf(normalizedEmail) === -1) {
        emails.push(normalizedEmail);
        localStorage.setItem('newsletter_subscribed_emails', JSON.stringify(emails));
      }
    } catch (e) {
      // Ignore localStorage errors
    }
  }
  
  // Check if email is already subscribed
  function isEmailSubscribed(email) {
    var emails = getSubscribedEmails();
    var normalizedEmail = email.toLowerCase().trim();
    return emails.indexOf(normalizedEmail) !== -1;
  }
  
  // Show error message in form
  function showDuplicateError(form, message) {
    // Remove existing alerts
    var existingAlert = form.querySelector('.Form__Alert, .Alert');
    if (existingAlert) {
      existingAlert.remove();
    }
    
    // Create error alert
    var errorAlert = document.createElement('p');
    errorAlert.className = 'Form__Alert Alert Alert--error';
    errorAlert.textContent = message;
    
    // Insert error alert before the form inputs
    var formInner = form.querySelector('.Newsletter__Inner, .NewsletterPopup__Form, .Footer__Newsletter');
    if (formInner) {
      form.insertBefore(errorAlert, formInner);
    } else {
      form.insertBefore(errorAlert, form.firstChild);
    }
    
    // Scroll to error if needed
    errorAlert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  
  // Get appropriate error message based on form context
  function getDuplicateErrorMessage(form) {
    // Try to get from hidden input with class newsletter-duplicate-message
    var messageInput = form.querySelector('.newsletter-duplicate-message');
    if (messageInput && messageInput.value) {
      return messageInput.value;
    }
    
    // Try to get from data attribute
    if (form.dataset && form.dataset.duplicateMessage) {
      return form.dataset.duplicateMessage;
    }
    
    // Try to get from Shopify theme translations
    if (window.theme && window.theme.strings) {
      if (form.id === 'newsletter-popup' && window.theme.strings.general && window.theme.strings.general.popup) {
        return window.theme.strings.general.popup.already_subscribed;
      }
      if (form.id === 'footer-newsletter' && window.theme.strings.footer && window.theme.strings.footer.newsletter) {
        return window.theme.strings.footer.newsletter.already_subscribed;
      }
      if (window.theme.strings.home_page && window.theme.strings.home_page.newsletter) {
        return window.theme.strings.home_page.newsletter.already_subscribed;
      }
    }
    // Fallback message
    return 'This email is already subscribed to our newsletter.';
  }
  
  // Handle newsletter form submissions
  document.addEventListener('submit', function(event) {
    var form = event.target;
    
    // Check if this is a newsletter form
    if (!form || form.tagName !== 'FORM') return;
    if (form.action.indexOf('/contact') === -1) return;
    
    var emailInput = form.querySelector('input[name="contact[email]"]');
    if (!emailInput) return;
    
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!tagsInput || tagsInput.value !== 'newsletter') return;
    
    var email = emailInput.value;
    if (!email) return;
    
    // Normalize email
    var normalizedEmail = email.toLowerCase().trim();
    
    // Check if email is already subscribed
    if (isEmailSubscribed(normalizedEmail)) {
      event.preventDefault();
      event.stopPropagation();
      
      var errorMessage = getDuplicateErrorMessage(form);
      showDuplicateError(form, errorMessage);
      
      return false;
    }
    
    // If not a duplicate, save email to localStorage before submission
    // This ensures it's saved even if the page reloads
    saveSubscribedEmail(normalizedEmail);
  }, true);
  
  // Handle successful newsletter subscriptions
  // This runs after the form is submitted and page reloads or form updates
  document.addEventListener('DOMContentLoaded', function() {
    // Check for successful submissions in the current page
    var newsletterForms = document.querySelectorAll('form[action*="/contact"]');
    
    newsletterForms.forEach(function(form) {
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      if (!tagsInput || tagsInput.value !== 'newsletter') return;
      
      var emailInput = form.querySelector('input[name="contact[email]"]');
      if (!emailInput) return;
      
      // Check if form shows success message (indicating successful submission)
      var successMessage = form.querySelector('.Alert--success, .Form__Alert.Alert--success');
      if (successMessage && emailInput.value) {
        // Save email as subscribed
        saveSubscribedEmail(emailInput.value);
      }
    });
  });
  
  // Also handle AJAX form submissions (if theme uses AJAX)
  // Listen for form submission events that might be handled via AJAX
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : args[0].url;
      
      if (url && url.indexOf('/contact') !== -1 && args[1] && args[1].body) {
        // Check if this is a newsletter subscription
        var body = args[1].body;
        if (typeof body === 'string' && body.indexOf('contact[tags]=newsletter') !== -1) {
          // Extract email from form data
          var emailMatch = body.match(/contact\[email\]=([^&]+)/);
          if (emailMatch) {
            var email = decodeURIComponent(emailMatch[1].replace(/\+/g, ' '));
            
            // Check for duplicate
            if (isEmailSubscribed(email)) {
              return Promise.reject(new Error('DUPLICATE_EMAIL'));
            }
            
            // Call original fetch
            return originalFetch.apply(this, args).then(function(response) {
              // If successful, save email
              if (response.ok) {
                saveSubscribedEmail(email);
              }
              return response;
            });
          }
        }
      }
      
      return originalFetch.apply(this, args);
    };
  }
})();


// ============================================
// Custom Smooth Accordion Toggle for PDP Page
// ============================================
(function() {
  'use strict';

  // Smooth accordion toggle functionality
  function initSmoothAccordion() {
    // Find all accordion buttons on the page
    var accordionButtons = document.querySelectorAll('[data-action="toggle-collapsible"]');
    
    if (accordionButtons.length === 0) return;

    accordionButtons.forEach(function(button) {
      if (button.hasAttribute('data-accordion-initialized')) return;
      button.setAttribute('data-accordion-initialized', 'true');

      var collapsible = button.closest('.Collapsible');
      if (!collapsible) return;
      var inner = collapsible.querySelector('.Collapsible__Inner');
      if (!inner) return;

      var defaultExpanded = button.getAttribute('aria-expanded') === 'true';
      collapsible.setAttribute('aria-expanded', defaultExpanded ? 'true' : 'false');
      if (defaultExpanded) {
        inner.style.height = 'auto';
        inner.style.overflow = 'visible';
        inner.style.opacity = '1';
        inner.style.pointerEvents = 'auto';
        inner.style.display = 'block';
      } else {
        inner.style.height = '0px';
        inner.style.overflow = 'hidden';
        inner.style.opacity = '0';
        inner.style.pointerEvents = 'none';
        inner.style.display = 'block';
      }

      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var collapsible = button.closest('.Collapsible');
        if (!collapsible) return;

        var inner = collapsible.querySelector('.Collapsible__Inner');
        if (!inner) return;

        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Close accordion smoothly
          closeAccordion(collapsible, button, inner);
        } else {
          // Close other open accordions in the same container
          var container = collapsible.closest('.Product__Tabs');
          if (container) {
            var openAccordions = container.querySelectorAll('.Collapsible[aria-expanded="true"]');
            openAccordions.forEach(function(openAccordion) {
              if (openAccordion !== collapsible) {
                var openButton = openAccordion.querySelector('.Collapsible__Button');
                var openInner = openAccordion.querySelector('.Collapsible__Inner');
                if (openButton && openInner) {
                  closeAccordion(openAccordion, openButton, openInner);
                }
              }
            });
          }
          
          // Open accordion smoothly
          openAccordion(collapsible, button, inner);
        }
      });
    });
  }

  // Smooth open function
  function openAccordion(collapsible, button, inner) {
    // Set initial state
    inner.style.overflow = 'hidden';
    inner.style.height = '0px';
    inner.style.display = 'block';
    inner.style.pointerEvents = 'none';
    inner.style.opacity = '0';
    
    // Get the actual height
    var height = inner.scrollHeight;
    
    // Set transition
    inner.style.transition = 'height 0.4s ease-in-out, opacity 0.3s ease-in-out';
    
    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(function() {
      inner.style.height = height + 'px';
      inner.style.opacity = '1';
    });
    
    // Update attributes
    button.setAttribute('aria-expanded', 'true');
    collapsible.setAttribute('aria-expanded', 'true');
    
    // Clean up after animation
    setTimeout(function() {
      inner.style.height = 'auto';
      inner.style.overflow = 'visible';
      inner.style.pointerEvents = 'auto';
      inner.style.opacity = '1';
    }, 400);
  }

  // Smooth close function
  function closeAccordion(collapsible, button, inner) {
    // Get current height
    var height = inner.scrollHeight;
    
    // Set transition
    inner.style.transition = 'height 0.4s ease-in-out, opacity 0.3s ease-in-out';
    inner.style.height = height + 'px';
    inner.style.overflow = 'hidden';
    inner.style.pointerEvents = 'none';
    
    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(function() {
      inner.style.height = '0px';
      inner.style.opacity = '0';
    });
    
    // Update attributes
    button.setAttribute('aria-expanded', 'false');
    collapsible.setAttribute('aria-expanded', 'false');
    
    // Clean up after animation
    setTimeout(function() {
      inner.style.height = '0px';
      inner.style.overflow = 'hidden';
      inner.style.opacity = '0';
    }, 400);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothAccordion);
  } else {
    initSmoothAccordion();
  }

  // Re-initialize for dynamically loaded content (AJAX)
  var observer = new MutationObserver(function(mutations) {
    var shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('Product__Tabs') ||
            node.querySelector && node.querySelector('.Product__Tabs') ||
            node.querySelector && node.querySelector('[data-action="toggle-collapsible"]')
          )) {
            shouldReinit = true;
          }
        });
      }
    });
    if (shouldReinit) {
      setTimeout(initSmoothAccordion, 100);
    }
  });

  // Product Tab Drawer functionality
  function initProductTabDrawer() {
    var drawer = document.getElementById('ProductTabDrawer');
    var backdrop = document.getElementById('ProductTabDrawerBackdrop');
    if (!drawer || !backdrop) return;

    var drawerTitle = document.getElementById('ProductTabDrawerTitle');
    var drawerContent = document.getElementById('ProductTabDrawerContent');

    // Open drawer buttons
    var openButtons = document.querySelectorAll('[data-action="open-product-drawer"]');
    openButtons.forEach(function(button) {
      if (button.hasAttribute('data-drawer-initialized')) return;
      button.setAttribute('data-drawer-initialized', 'true');

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var drawerId = button.getAttribute('data-drawer-id');
        var contentId = drawerId + '-content';
        var contentElement = document.getElementById(contentId);
        var buttonText = button.querySelector('.ProductTab__ButtonText');

        if (!contentElement || !drawerTitle || !drawerContent) return;

        // Get title text (remove any nested spans)
        var titleText = buttonText ? buttonText.textContent.trim() : button.textContent.trim();
        if (titleText.includes('(')) {
          titleText = titleText.split('(')[0].trim();
        }

        // Set drawer content
        drawerTitle.textContent = titleText.toUpperCase();
        drawerContent.innerHTML = contentElement.innerHTML;

        // Open drawer and backdrop
        drawer.setAttribute('aria-hidden', 'false');
        backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('product-drawer-active');

        // Scroll to top of drawer content
        drawerContent.scrollTop = 0;
      });
    });

    // Close drawer buttons (including backdrop)
    var closeButtons = document.querySelectorAll('[data-action="close-product-drawer"]');
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeProductTabDrawer();
      });
    });

    // Close drawer on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeProductTabDrawer();
      }
    });
  }

  function closeProductTabDrawer() {
    var drawer = document.getElementById('ProductTabDrawer');
    var backdrop = document.getElementById('ProductTabDrawerBackdrop');
    if (!drawer || !backdrop) return;

    drawer.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
    document.body.classList.remove('product-drawer-active');
  }

  // Initialize drawer on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabDrawer);
  } else {
    initProductTabDrawer();
  }

  // Re-initialize drawer for dynamically loaded content
  var drawerObserver = new MutationObserver(function(mutations) {
    var shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('Product__Tabs') ||
            node.querySelector && node.querySelector('.Product__Tabs') ||
            node.querySelector && node.querySelector('[data-action="open-product-drawer"]')
          )) {
            shouldReinit = true;
          }
        });
      }
    });
    if (shouldReinit) {
      setTimeout(initProductTabDrawer, 100);
    }
  });

  if (document.body) {
    drawerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

// ============================================
// Color Swatch Radio Button Fix
// ============================================
(function() {
  'use strict';

  function initColorSwatchFix() {
    var colorSwatchLabels = document.querySelectorAll('.ColorSwatchBox[data-color-swatch]');
    
    colorSwatchLabels.forEach(function(label) {
      if (label.hasAttribute('data-swatch-initialized')) return;
      label.setAttribute('data-swatch-initialized', 'true');

      label.addEventListener('click', function(e) {
        var radioId = label.getAttribute('for');
        if (!radioId) return;

        var radio = document.getElementById(radioId);
        if (!radio) return;

        // Get all radio buttons in the same group (same name)
        var radioGroup = document.querySelectorAll('input[type="radio"][name="' + radio.name + '"]');
        
        // Uncheck all radios in the group
        radioGroup.forEach(function(r) {
          r.removeAttribute('checked');
          r.checked = false;
          
          // Remove selected class from all labels in the group
          var labelForR = document.querySelector('label[for="' + r.id + '"]');
          if (labelForR) {
            labelForR.classList.remove('ColorSwatchBox--selected');
          }
        });

        // Check the clicked radio
        radio.setAttribute('checked', 'checked');
        radio.checked = true;
        
        // Add selected class to clicked label
        label.classList.add('ColorSwatchBox--selected');

        // Trigger change event for any listeners
        var changeEvent = new Event('change', { bubbles: true, cancelable: true });
        radio.dispatchEvent(changeEvent);
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatchFix);
  } else {
    initColorSwatchFix();
  }

  // Re-initialize for dynamically loaded content
  var swatchObserver = new MutationObserver(function(mutations) {
    var shouldReinit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('ColorSwatchBox') ||
            node.querySelector && node.querySelector('.ColorSwatchBox')
          )) {
            shouldReinit = true;
          }
        });
      }
    });
    if (shouldReinit) {
      setTimeout(initColorSwatchFix, 100);
    }
  });

  if (document.body) {
    swatchObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();








// ============================================
// Mobile Menu functionality moved to header.js
// ============================================





// Make arrow clickable in text-button--arrow
(function() {
  document.addEventListener('click', function(e) {
    var img = e.target;
    if (img.tagName === 'IMG') {
      var container = img.closest('.text-button--arrow');
      if (container) {
        var link = container.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = link.href;
        }
      }
    }
  });
})();

// ============================================
// Update PDP gallery when color option changes
// ============================================
(function() {
  'use strict';
  var galleryRequestCache = {};

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function getColorOptionIndex(sectionElement) {
    var productJsonElement = sectionElement.querySelector('[data-product-json]');
    if (!productJsonElement) return -1;

    try {
      var parsed = JSON.parse(productJsonElement.textContent);
      var options = parsed && parsed.product && parsed.product.options;
      if (!options || !options.length) return -1;

      for (var i = 0; i < options.length; i += 1) {
        var optionName = normalize(options[i]);
        if (optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1) {
          return i;
        }
      }
    } catch (e) {
      return -1;
    }

    return -1;
  }

  function getVariantOptionValue(variant, optionIndex) {
    if (!variant || optionIndex < 0) return '';

    if (variant.options && typeof variant.options[optionIndex] !== 'undefined') {
      return variant.options[optionIndex];
    }

    var key = 'option' + (optionIndex + 1);
    return variant[key] || '';
  }

  function getSectionCheckedColorValue(sectionElement) {
    if (!sectionElement) return '';
    var checkedColor = sectionElement.querySelector('.ColorSwatch__Radio:checked');
    return checkedColor ? normalize(checkedColor.value) : '';
  }

  function getActiveGalleryColor(sectionElement) {
    if (!sectionElement) return '';
    return normalize(sectionElement.getAttribute('data-active-gallery-color') || getSectionCheckedColorValue(sectionElement));
  }

  function setActiveGalleryColor(sectionElement, colorValue) {
    if (!sectionElement) return;
    sectionElement.setAttribute('data-active-gallery-color', normalize(colorValue));
  }

  function getActiveGalleryVariantId(sectionElement) {
    if (!sectionElement) return '';
    return String(sectionElement.getAttribute('data-active-gallery-variant-id') || '');
  }

  function setActiveGalleryVariantId(sectionElement, variantId) {
    if (!sectionElement || !variantId) return;
    sectionElement.setAttribute('data-active-gallery-variant-id', String(variantId));
  }

  /**
   * True when a color change will load new gallery HTML (same test as the bubble variant:changed handler).
   * Used in capture phase so the theme can skip #Media anchor .click() on stale DOM (see theme ProductSection _updateSlideshowImage).
   */
  function shouldRefreshPdpGalleryForColorChange(sectionElement, previousVariant, variant) {
    if (!sectionElement || !previousVariant || !variant) {
      return { should: false, nextColor: '' };
    }
    var colorOptionIndex = getColorOptionIndex(sectionElement);
    if (colorOptionIndex < 0) {
      return { should: false, nextColor: '' };
    }
    var prevColor = normalize(getVariantOptionValue(previousVariant, colorOptionIndex));
    var nextColor = normalize(getVariantOptionValue(variant, colorOptionIndex));
    if (
      prevColor &&
      nextColor &&
      prevColor !== nextColor &&
      String(variant.id) !== String(previousVariant.id) &&
      nextColor !== getActiveGalleryColor(sectionElement)
    ) {
      return { should: true, nextColor: nextColor };
    }
    return { should: false, nextColor: nextColor || '' };
  }

  function getProductDataFromSection(sectionElement) {
    if (!sectionElement) return null;
    var productJsonElement = sectionElement.querySelector('[data-product-json]');
    if (!productJsonElement) return null;

    try {
      var parsed = JSON.parse(productJsonElement.textContent);
      return parsed && parsed.product ? parsed.product : null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionValues(sectionElement, productData) {
    var values = [];
    if (!sectionElement || !productData || !productData.options) return values;

    for (var i = 0; i < productData.options.length; i += 1) {
      values[i] = '';
      var checkedInput = sectionElement.querySelector('[name="option-' + i + '"]:checked');
      if (checkedInput) {
        values[i] = checkedInput.value || '';
      }
    }

    return values;
  }

  function findVariantIdForColor(sectionElement, colorValue) {
    var productData = getProductDataFromSection(sectionElement);
    if (!productData || !productData.variants || !productData.variants.length) return null;

    var colorOptionIndex = getColorOptionIndex(sectionElement);
    if (colorOptionIndex < 0) return null;

    var normalizedColor = normalize(colorValue);
    if (!normalizedColor) return null;

    var selectedOptions = getSelectedOptionValues(sectionElement, productData);
    selectedOptions[colorOptionIndex] = colorValue;

    var exactMatchVariant = null;
    var sameColorWithFeatured = null;
    var sameColorVariant = null;

    productData.variants.forEach(function(variant) {
      var variantColor = normalize(getVariantOptionValue(variant, colorOptionIndex));
      if (variantColor !== normalizedColor) return;

      if (!sameColorVariant) {
        sameColorVariant = variant;
      }

      if (!sameColorWithFeatured && variant.featured_media) {
        sameColorWithFeatured = variant;
      }

      if (exactMatchVariant) return;

      var isExact = true;
      for (var i = 0; i < productData.options.length; i += 1) {
        var selectedValue = normalize(selectedOptions[i]);
        if (!selectedValue) continue;

        var variantValue = normalize(getVariantOptionValue(variant, i));
        if (variantValue !== selectedValue) {
          isExact = false;
          break;
        }
      }

      if (isExact) {
        exactMatchVariant = variant;
      }
    });

    return (exactMatchVariant && exactMatchVariant.id)
      || (sameColorWithFeatured && sameColorWithFeatured.id)
      || (sameColorVariant && sameColorVariant.id)
      || null;
  }

  function getCacheKey(sectionElement, variantId) {
    return (sectionElement.getAttribute('data-section-id') || 'section') + ':' + String(variantId);
  }

  function getImageUrlForPreload(imageElement) {
    if (!imageElement) return '';

    var dataSrc = imageElement.getAttribute('data-src');
    if (dataSrc) {
      return dataSrc.replace('{width}x', '1200x');
    }

    return imageElement.getAttribute('src') || '';
  }

  function preloadGalleryFirstImage(galleryElement) {
    if (!galleryElement) return;

    var firstImage = galleryElement.querySelector('.Product__SlideItem--image img, .MobileProductSlider__Image');
    var imageUrl = getImageUrlForPreload(firstImage);
    if (!imageUrl) return;

    var preloader = new Image();
    preloader.src = imageUrl;
  }

  function fetchGalleryMarkup(sectionElement, variantId) {
    var cacheKey = getCacheKey(sectionElement, variantId);
    if (galleryRequestCache[cacheKey]) {
      return galleryRequestCache[cacheKey];
    }

    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) {
      return Promise.reject(new Error('Missing section id'));
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    galleryRequestCache[cacheKey] = fetch(url.toString(), { credentials: 'same-origin' })
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var nextGallery = doc.querySelector('.Product__Gallery');
        if (nextGallery) {
          preloadGalleryFirstImage(nextGallery);
        }

        return html;
      })
      .catch(function(error) {
        delete galleryRequestCache[cacheKey];
        throw error;
      });

    return galleryRequestCache[cacheKey];
  }

  function waitForIncomingGalleryImage(nextGallery) {
    return new Promise(function(resolve) {
      if (!nextGallery) {
        resolve();
        return;
      }

      var firstImage = nextGallery.querySelector('.Product__SlideItem--image img, .MobileProductSlider__Image');
      if (!firstImage) {
        resolve();
        return;
      }

      if (firstImage.complete && firstImage.naturalWidth > 0) {
        resolve();
        return;
      }

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }

      firstImage.addEventListener('load', finish, { once: true });
      firstImage.addEventListener('error', finish, { once: true });
      // Cap wait so color switches stay responsive; layout may still settle via releaseHeights.
      setTimeout(finish, 500);
    });
  }

  function initMobileSwiperInSection(sectionElement, retriesLeft) {
    if (!sectionElement) return;

    var sliderEl = sectionElement.querySelector('.mobile-product-slider-js');
    if (!sliderEl) return;

    if (sliderEl.swiper) {
      sliderEl.swiper.update();
      return;
    }

    if (typeof Swiper === 'undefined') {
      if (retriesLeft > 0) {
        setTimeout(function() {
          initMobileSwiperInSection(sectionElement, retriesLeft - 1);
        }, 120);
      }
      return;
    }

    var prevBtn = sectionElement.querySelector('.MobileProductSlider__Arrow--prev');
    var nextBtn = sectionElement.querySelector('.MobileProductSlider__Arrow--next');

    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 400,
      autoplay: false,
      allowTouchMove: true,
      grabCursor: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },
      on: {
        init: function() {
          sliderEl.style.maxHeight = '280px';
        }
      }
    });
  }

  function prefetchColorVariantGalleries(sectionElement) {
    if (!sectionElement) return;

    var productJsonElement = sectionElement.querySelector('[data-product-json]');
    if (!productJsonElement) return;

    var colorOptionIndex = getColorOptionIndex(sectionElement);
    if (colorOptionIndex < 0) return;

    var parsed;
    try {
      parsed = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      return;
    }

    var variants = parsed && parsed.product && parsed.product.variants ? parsed.product.variants : [];
    if (!variants.length) return;

    var requestedColorValues = {};
    variants.forEach(function(variant) {
      var colorValue = normalize(getVariantOptionValue(variant, colorOptionIndex));
      if (!colorValue || requestedColorValues[colorValue]) return;
      requestedColorValues[colorValue] = true;

      fetchGalleryMarkup(sectionElement, variant.id).catch(function() {});
    });
  }

  function applyTemporaryGalleryHeights(currentGallery, nextGallery) {
    if (!currentGallery || !nextGallery || !currentGallery.parentNode) return null;

    var state = {
      parent: currentGallery.parentNode,
      parentMinHeight: currentGallery.parentNode.style.minHeight,
      galleryMinHeight: nextGallery.style.minHeight
    };

    var currentGalleryHeight = Math.round(currentGallery.getBoundingClientRect().height);
    if (currentGalleryHeight > 0) {
      state.parent.style.minHeight = currentGalleryHeight + 'px';
      nextGallery.style.minHeight = currentGalleryHeight + 'px';
    }

    var currentDesktop = currentGallery.querySelector('.Product__Slideshow--desktop');
    var nextDesktop = nextGallery.querySelector('.Product__Slideshow--desktop');
    if (currentDesktop && nextDesktop) {
      state.desktopMinHeight = nextDesktop.style.minHeight;
      var desktopHeight = Math.round(currentDesktop.getBoundingClientRect().height);
      if (desktopHeight > 0) {
        nextDesktop.style.minHeight = desktopHeight + 'px';
      }
    }

    var currentMobile = currentGallery.querySelector('.MobileProductSlider');
    var nextMobile = nextGallery.querySelector('.MobileProductSlider');
    if (currentMobile && nextMobile) {
      state.mobileMinHeight = nextMobile.style.minHeight;
      var mobileHeight = Math.round(currentMobile.getBoundingClientRect().height);
      if (mobileHeight > 0) {
        nextMobile.style.minHeight = mobileHeight + 'px';
      }
    }

    return state;
  }

  function releaseTemporaryGalleryHeights(gallery, state) {
    if (!gallery || !state) return;

    if (state.parent) {
      state.parent.style.minHeight = typeof state.parentMinHeight === 'string' ? state.parentMinHeight : '';
    }

    gallery.style.minHeight = typeof state.galleryMinHeight === 'string' ? state.galleryMinHeight : '';

    var nextDesktop = gallery.querySelector('.Product__Slideshow--desktop');
    if (nextDesktop && typeof state.desktopMinHeight !== 'undefined') {
      nextDesktop.style.minHeight = state.desktopMinHeight;
    }

    var nextMobile = gallery.querySelector('.MobileProductSlider');
    if (nextMobile && typeof state.mobileMinHeight !== 'undefined') {
      nextMobile.style.minHeight = state.mobileMinHeight;
    }
  }

  function releaseHeightsWhenImageReady(releaseForGallery, state, onReady) {
    if (!releaseForGallery || !state) return;

    var firstImage = releaseForGallery.querySelector('.Product__SlideItem--image img, .MobileProductSlider__Image');
    if (!firstImage) {
      releaseTemporaryGalleryHeights(releaseForGallery, state);
      if (typeof onReady === 'function') onReady();
      return;
    }

    var released = false;
    function releaseNow() {
      if (released) return;
      released = true;
      releaseTemporaryGalleryHeights(releaseForGallery, state);
      if (typeof onReady === 'function') onReady();
    }

    if (firstImage.complete && firstImage.naturalWidth > 0) {
      releaseNow();
      return;
    }

    firstImage.addEventListener('load', releaseNow, { once: true });
    firstImage.addEventListener('error', releaseNow, { once: true });
    setTimeout(releaseNow, 1000);
  }

  function hideVtoButtonsDuringSwap(galleryElement) {
    if (!galleryElement) return;

    var buttons = galleryElement.querySelectorAll('.product-page__vto-button');
    buttons.forEach(function(button) {
      button.setAttribute('data-temp-hidden-vto', 'true');
      button.style.opacity = '0';
      button.style.pointerEvents = 'none';
      button.style.transition = 'opacity 160ms ease';
    });
  }

  function revealVtoButtonsAfterSwap(galleryElement) {
    if (!galleryElement) return;

    var buttons = galleryElement.querySelectorAll('.product-page__vto-button[data-temp-hidden-vto="true"]');
    buttons.forEach(function(button) {
      button.style.opacity = '';
      button.style.pointerEvents = '';
      button.removeAttribute('data-temp-hidden-vto');
    });
  }

  function preserveExistingSprieMarkup(currentGallery, nextGallery, variantSku) {
    if (!currentGallery || !nextGallery) return;

    var currentWrapper = currentGallery.querySelector('.sprie-embed-element-wrapper');
    if (!currentWrapper) return;

    var nextWrapper = nextGallery.querySelector('.sprie-embed-element-wrapper');
    if (nextWrapper && nextWrapper.parentNode) {
      // Keep the existing live Sprie node and prevent fetched HTML from replacing it.
      nextWrapper.parentNode.replaceChild(currentWrapper, nextWrapper);
      return;
    }

    // Fallback: if incoming gallery has no Sprie node, carry existing one forward.
    nextGallery.appendChild(currentWrapper);
  }

  /**
   * Replace only image / slideshow / VTO chrome from fetched HTML; keep the live Sprie node and anchor
   * in the DOM (no reparent, no new Sprie HTML). Stack layout only. Falls back to full replace if
   * there is no Sprie embed in the current gallery.
   */
  function mergeProductGalleryKeepSprie(liveGallery, nextGallery) {
    if (!liveGallery || !nextGallery) return false;
    if (!liveGallery.classList.contains('Product__Gallery--stack')) return false;

    var sprie = liveGallery.querySelector('.sprie-embed-element-wrapper');
    if (!sprie) return false;

    var i;
    for (i = liveGallery.children.length - 1; i >= 0; i -= 1) {
      var ch = liveGallery.children[i];
      if (ch === sprie) continue;
      if (ch.getAttribute('id') === 'ProductGallery') continue;
      ch.remove();
    }

    for (i = 0; i < nextGallery.children.length; i += 1) {
      var nx = nextGallery.children[i];
      if (nx.classList && nx.classList.contains('sprie-embed-element-wrapper')) continue;
      if (nx.getAttribute('id') === 'ProductGallery') continue;
      liveGallery.appendChild(document.importNode(nx, true));
    }

    if (nextGallery.getAttribute('class')) {
      liveGallery.setAttribute('class', nextGallery.getAttribute('class'));
    }
    return true;
  }

  function refreshGalleryForVariant(sectionElement, variantId, variantSku, forceKeepSprieVisible) {
    if (!sectionElement || !variantId) return;
    if (sectionElement.getAttribute('data-gallery-refreshing') === 'true') return;

    if (String(getActiveGalleryVariantId(sectionElement)) === String(variantId)) {
      return;
    }

    var now = Date.now();
    var lastVariantId = sectionElement.getAttribute('data-gallery-last-variant-id');
    var lastVariantAt = parseInt(sectionElement.getAttribute('data-gallery-last-variant-at') || '0', 10);
    if (String(lastVariantId) === String(variantId) && (now - lastVariantAt) < 500) {
      return;
    }

    sectionElement.setAttribute('data-gallery-refresh-variant-id', String(variantId));

    sectionElement.setAttribute('data-gallery-refreshing', 'true');
    // Avoid running SprieSDK.CheckSKU in footer-apps on the same variant:changed tick while this
    // async refresh is in flight; footer defers SprieSDK.CheckSKU until after this completes.
    sectionElement.setAttribute('data-cp-defer-sprie-checksku', '1');

    var completedFullGallerySwap = false;

    fetchGalleryMarkup(sectionElement, variantId)
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var nextGallery = doc.querySelector('.Product__Gallery');
        var currentGallery = sectionElement.querySelector('.Product__Gallery');

        if (!nextGallery || !currentGallery || !currentGallery.parentNode) {
          return;
        }

        // Must return this promise so .finally runs only after the gallery swap and Sprie restore
        // (previously the outer .then did not return, so .finally cleared state before DOM updated).
        return waitForIncomingGalleryImage(nextGallery).then(function() {
          var latestCurrentGallery = sectionElement.querySelector('.Product__Gallery');
          if (!latestCurrentGallery || !latestCurrentGallery.parentNode) {
            return;
          }

          var currentSprieWrapper = latestCurrentGallery.querySelector('.sprie-embed-element-wrapper');
          var shouldKeepSprieVisible = !!forceKeepSprieVisible || !!(currentSprieWrapper && !currentSprieWrapper.classList.contains('is-hidden'));

          var heightState = applyTemporaryGalleryHeights(latestCurrentGallery, nextGallery);
          hideVtoButtonsDuringSwap(nextGallery);

          var imagesOnlyRefresh = mergeProductGalleryKeepSprie(latestCurrentGallery, nextGallery);
          var releaseHeightsTarget = latestCurrentGallery;

          if (!imagesOnlyRefresh) {
            preserveExistingSprieMarkup(latestCurrentGallery, nextGallery, variantSku);
            latestCurrentGallery.parentNode.replaceChild(nextGallery, latestCurrentGallery);
            releaseHeightsTarget = nextGallery;
          }

          // Always set data-sprie-sku for the new variant, even when 360 is closed (is-hidden), so
          // the next open uses the current colour — not only when restoreSprie* used to "keep visible".
          syncSprieSkuInSection(sectionElement, variantSku, shouldKeepSprieVisible);

          if (window.lazySizes && window.lazySizes.loader) {
            window.lazySizes.loader.checkElems();
          }

          initMobileSwiperInSection(sectionElement, 15);
          return new Promise(function(resolve) {
            releaseHeightsWhenImageReady(releaseHeightsTarget, heightState, function() {
              revealVtoButtonsAfterSwap(releaseHeightsTarget);
              setTimeout(function() {
                completedFullGallerySwap = true;
                resolve();
              }, 0);
            });
          });
        });
      })
      .catch(function() {})
      .finally(function() {
        var deferredSprie = sectionElement.getAttribute('data-cp-defer-sprie-checksku') === '1';
        if (deferredSprie) {
          sectionElement.removeAttribute('data-cp-defer-sprie-checksku');
        }
        if (deferredSprie && typeof window.__cpCheckSprieSku === 'function') {
          if (completedFullGallerySwap) {
            var runCheck = function() {
              if (typeof window.__cpCheckSprieSku === 'function') {
                window.__cpCheckSprieSku();
              }
            };
            if (typeof queueMicrotask === 'function') {
              queueMicrotask(runCheck);
            } else {
              setTimeout(runCheck, 0);
            }
          } else {
            window.__cpCheckSprieSku();
          }
        }
        sectionElement.setAttribute('data-gallery-last-variant-id', String(variantId));
        sectionElement.setAttribute('data-gallery-last-variant-at', String(Date.now()));
        setActiveGalleryVariantId(sectionElement, variantId);
        sectionElement.removeAttribute('data-gallery-refresh-variant-id');
        sectionElement.removeAttribute('data-gallery-refreshing');
      });
  }

  function syncSprieSkuInSection(sectionElement, variantSku, keepSprieVisible) {
    if (!sectionElement) return;
    var sprieWrapper = sectionElement.querySelector('.sprie-embed-element-wrapper');
    var sprieElement = sectionElement.querySelector('.sprie-embed-element');
    if (!sprieElement) return;

    if (variantSku) {
      var currentSku = sprieElement.getAttribute('data-sprie-sku') || '';
      if (String(currentSku) !== String(variantSku)) {
        sprieElement.setAttribute('data-sprie-sku', variantSku);
      }
    }

    if (keepSprieVisible && sprieWrapper) {
      sprieWrapper.classList.remove('is-hidden');
    }
  }

  function syncLensadvizorVariantInSection(sectionElement, variantId) {
    if (!sectionElement || !variantId) return;

    var lensButtons = sectionElement.querySelectorAll('lensadvizor-quick-buy[data-la-variant-id]');
    if (!lensButtons || !lensButtons.length) return;

    var nextVariantId = String(variantId);
    lensButtons.forEach(function(button) {
      if (button.getAttribute('data-la-variant-id') !== nextVariantId) {
        button.setAttribute('data-la-variant-id', nextVariantId);
      }
    });
  }

  function schedulePrefetch(sectionElement) {
    if (!sectionElement) return;

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function() {
        prefetchColorVariantGalleries(sectionElement);
      }, { timeout: 1800 });
      return;
    }

    setTimeout(function() {
      prefetchColorVariantGalleries(sectionElement);
    }, 600);
  }

  function initGalleryPrefetch() {
    var sections = document.querySelectorAll('[data-section-type="product"]');
    sections.forEach(function(sectionElement) {
      setActiveGalleryColor(sectionElement, getSectionCheckedColorValue(sectionElement));
      schedulePrefetch(sectionElement);
    });
  }

  // Run in capture: runs before the theme’s ProductSection _updateSlideshowImage (stacked gallery) simulates
  // a link click, which would run against pre-fetch DOM and can stack with a full gallery replace + Sprie restore.
  document.addEventListener(
    'variant:changed',
    function(event) {
      var t = event.target;
      if (!t) return;
      var sectionElement =
        t.getAttribute('data-section-type') === 'product' ? t : t.closest && t.closest('[data-section-type="product"]');
      if (!sectionElement) return;
      var detail = event.detail || {};
      var decision = shouldRefreshPdpGalleryForColorChange(
        sectionElement,
        detail.previousVariant,
        detail.variant
      );
      if (decision.should) {
        sectionElement.setAttribute('data-cp-skip-slideshow', '1');
      }
    },
    true
  );

  document.addEventListener('variant:changed', function(event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    var previousVariant = detail.previousVariant;
    var sectionElement = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : null;

    if (!sectionElement || !variant) return;
    sectionElement.setAttribute('data-last-variant-changed-at', String(Date.now()));

    // Keep LensAdvizor quick-buy in sync with selected variant.
    syncLensadvizorVariantInSection(sectionElement, variant.id);

    var sprieWrapper = sectionElement.querySelector('.sprie-embed-element-wrapper');
    var keepSprieVisible = !!(sprieWrapper && !sprieWrapper.classList.contains('is-hidden'));

    var gallery = shouldRefreshPdpGalleryForColorChange(sectionElement, previousVariant, variant);
    if (gallery.should) {
      // For color-driven image swaps, gallery refresh path owns Sprie SKU sync.
      setActiveGalleryColor(sectionElement, gallery.nextColor);
      refreshGalleryForVariant(sectionElement, variant.id, variant.sku, keepSprieVisible);
      return;
    }

    // For non-color changes (or missing previousVariant), keep Sprie in sync directly.
    syncSprieSkuInSection(sectionElement, variant.sku, keepSprieVisible);
  });

  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('.ColorSwatch__Radio')) return;

    var sectionElement = target.closest('[data-section-type="product"]');
    if (!sectionElement) return;
    // `variant:changed` is the single source of truth for PDP gallery refresh.
    // Keep this listener only for diagnostics/bookkeeping to avoid duplicate rerenders.
    sectionElement.setAttribute('data-last-swatch-change-at', String(Date.now()));
  });

  function getZoomImagesFromSection(sectionElement) {
    if (!sectionElement) return [];
    return Array.prototype.slice.call(sectionElement.querySelectorAll('.Product__SlideItem--image img'));
  }

  function getZoomIndexFromSection(sectionElement, images) {
    if (!sectionElement || !images || !images.length) return 0;

    var selectedSlide = sectionElement.querySelector('.Product__Slideshow .is-selected[data-image-media-position]');
    if (selectedSlide) {
      var mediaPosition = parseInt(selectedSlide.getAttribute('data-image-media-position'), 10);
      if (!isNaN(mediaPosition) && mediaPosition >= 0 && mediaPosition < images.length) {
        return mediaPosition;
      }

      var selectedImage = selectedSlide.querySelector('img');
      if (selectedImage) {
        var selectedIndex = images.indexOf(selectedImage);
        if (selectedIndex >= 0) return selectedIndex;
      }
    }

    return 0;
  }

  function createZoomItems(images) {
    return images.map(function(image) {
      var src = image.getAttribute('data-original-src') || image.currentSrc || image.src;
      var width = parseInt(image.getAttribute('data-max-width') || image.naturalWidth || 1200, 10);
      var height = parseInt(image.getAttribute('data-max-height') || image.naturalHeight || 1200, 10);

      return {
        msrc: image.currentSrc || image.src,
        src: src,
        w: width,
        h: height,
        initialZoomLevel: 0.65
      };
    });
  }

  document.addEventListener('click', function(event) {
    var zoomButton = event.target && event.target.closest ? event.target.closest('[data-action="open-product-zoom"]') : null;
    if (!zoomButton) return;

    var sectionElement = zoomButton.closest('[data-section-type="product"]');
    if (!sectionElement) return;

    var images = getZoomImagesFromSection(sectionElement);
    var photoSwipeContainer = document.querySelector('.pswp');
    if (!images.length || !photoSwipeContainer || typeof window.PhotoSwipe !== 'function') return;

    event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    } else {
      event.stopPropagation();
    }

    var items = createZoomItems(images);
    var selectedIndex = getZoomIndexFromSection(sectionElement, images);

    var instance = new window.PhotoSwipe(photoSwipeContainer, false, items, {
      index: selectedIndex,
      showHideOpacity: true,
      showAnimationDuration: 500,
      loop: false,
      history: false,
      closeOnVerticalDrag: false,
      allowPanToNext: false,
      pinchToClose: false,
      scaleMode: 'zoom'
    });

    instance.init();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryPrefetch);
  } else {
    initGalleryPrefetch();
  }
})();

// ============================================
// Collection card "Notify me" → PDP redirect with BIS open
// ============================================
(function() {
  'use strict';

  // When clicking notify button on collection card, go to PDP with correct variant
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.CollectionSliderCard__IconOnlyBtn--notify.klaviyo-bis-trigger');
    if (!btn) return;

    // Prevent Klaviyo from opening BIS on collection page
    e.preventDefault();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    } else {
      e.stopPropagation();
    }

    // Find parent card
    var card =
      btn.closest('.ProductItem.CollectionSliderCard') ||
      btn.closest('.CollectionSliderCard') ||
      btn.closest('.ProductItem');

    var variantUrl = null;

    if (card) {
      // Prefer currently selected color swatch
      var selectedColorRadio = card.querySelector('.ColorSwatch__Radio:checked');

      if (selectedColorRadio) {
        // Try to use variant-specific URL from the swatch label
        var swatchItem = selectedColorRadio.closest('.ProductItem__ColorSwatchItem');
        if (swatchItem) {
          var label = swatchItem.querySelector('label[data-variant-url]');
          if (label && label.getAttribute('data-variant-url')) {
            variantUrl = label.getAttribute('data-variant-url');
          }
        }

        // Fallback: build URL with ?variant=ID
        if (!variantUrl) {
          var variantId = selectedColorRadio.getAttribute('data-variant-id');
          if (variantId) {
            var baseHref = null;

            var titleLink =
              card.querySelector('.ProductItem__Title a') ||
              card.querySelector('[data-card-title-url]') ||
              card.querySelector('.uc-product-card__title a');
            if (titleLink && titleLink.getAttribute('href')) {
              baseHref = titleLink.getAttribute('href');
            } else if (card.getAttribute && card.getAttribute('data-product-handle')) {
              baseHref = '/products/' + card.getAttribute('data-product-handle');
            }

            if (baseHref) {
              var urlObj = new URL(baseHref, window.location.origin);
              urlObj.searchParams.set('variant', variantId);
              variantUrl = urlObj.pathname + urlObj.search + urlObj.hash;
            }
          }
        }
      }

      // Final fallback: simple product URL
      if (!variantUrl) {
        var titleLinkFallback =
          card.querySelector('.ProductItem__Title a') ||
          card.querySelector('[data-card-title-url]') ||
          card.querySelector('.uc-product-card__title a');
        if (titleLinkFallback && titleLinkFallback.getAttribute('href')) {
          variantUrl = titleLinkFallback.getAttribute('href');
        }
      }
    }

    if (!variantUrl) return;

    // Add flag in URL so PDP knows to open BIS
    try {
      var finalUrl = new URL(variantUrl, window.location.origin);
      finalUrl.searchParams.set('bis_open', '1');
      window.location.href = finalUrl.pathname + finalUrl.search + finalUrl.hash;
    } catch (err) {
      // If URL construction fails, just navigate directly
      window.location.href = variantUrl;
    }
  }, true);

  (function () {
    var FORM_ID = 'Vg3VM5';
  
    function openBIS() {
      var url = new URL(window.location.href);
  
      // store flag (handles navigation cases)
      if (url.searchParams.get('bis_open') === '1') {
        sessionStorage.setItem('bis_open', '1');
      }
  
      if (sessionStorage.getItem('bis_open') !== '1') return;
  
      sessionStorage.removeItem('bis_open');
  
      // small delay to allow Klaviyo + DOM
      setTimeout(function () {
        if (window._klOnsite) {
          window._klOnsite.push(['openForm', FORM_ID]);
        } else {
          var btn = document.querySelector('.klaviyo-bis-trigger');
          if (btn) btn.click();
        }
      }, 700);
    }
  
    // run on first load
    document.addEventListener('DOMContentLoaded', openBIS);
  
    // run on navigation (Shopify internal)
    var pushState = history.pushState;
    history.pushState = function () {
      pushState.apply(this, arguments);
      setTimeout(openBIS, 300);
    };
  
  })();
})();
// ============================================
// Quantity selector visibility on variant change
// ============================================
(function() {
  'use strict';

  function updateQuantitySelector(container, variant) {
    if (!container || !container.querySelector) return;

    var quantitySelector = container.querySelector('.ProductForm__QuantitySelector');
    if (!quantitySelector) return;

    if (variant && variant.available) {
      quantitySelector.style.display = '';
    } else {
      quantitySelector.style.display = 'none';
    }
  }

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail && event.detail.variant;
    var origin = event.target;

    if (origin && origin.closest) {
      var productContainer = origin.closest('.Product') || origin.closest('.ProductForm') || origin;
      updateQuantitySelector(productContainer, variant);
    } else {
      updateQuantitySelector(document, variant);
    }
  });
})();




